import { EntFarmOwner } from "../../../models/farmOwners";
import { EntFarmOwnerFilter } from "../../../models/filters/farmOwnersFilter";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";



export const rolesApi = agroApi.injectEndpoints({
    endpoints: (builder) => ({
        getFarmOwnersList: builder.query<ResponseDataGet<EntFarmOwner>, EntFarmOwnerFilter>({
            query: (filter) => ({
                url: "/breeding-farms-owner/get-all",
                method: "POST",
                body: JSON.stringify(filter),  

            }),
        }),
        getFarmOwnersById: builder.query<ResponseDataTest<EntFarmOwner>, number>({
            query: (id) => ({
                url: `/breeding-farms-owner/${id}`,
                method: 'GET'
            })
        }),
        addFarmOwner: builder.mutation<ResponseDataGet<EntFarmOwner>, EntFarmOwner>({
            query: (body) => ({
              url: `/breeding-farms-owner`,
              method: "POST",
              body: JSON.stringify(body)
            }),
            onQueryStarted: async (user, { dispatch, queryFulfilled }) => {
              try {
      
              } catch { }
            }
          }),
          editFarmOwner: builder.mutation<ResponseDataGet<EntFarmOwner>, EntFarmOwner>({
            query: (body, ) => ({
              url: `/breeding-farms-owner`,
              method: 'PUT',
              body: JSON.stringify(body),
            }),
            onQueryStarted: async (user, { dispatch, queryFulfilled }) => {}
          }),
          deleteFarmOwner: builder.mutation<ResponseDataGet<EntFarmOwner>, number>({
            query: (id) => ({
              url: `/breeding-farms-owner/${id}`,
              method: 'DELETE',
            }),
            onQueryStarted: async (id, { dispatch, queryFulfilled }) => { }
          }),
    }),
    overrideExisting: false,
});

export const {
    useAddFarmOwnerMutation,
    useDeleteFarmOwnerMutation,
    useEditFarmOwnerMutation,
    useGetFarmOwnersByIdQuery,
    useGetFarmOwnersListQuery,
    useLazyGetFarmOwnersListQuery
} = rolesApi;
